/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./attachmentsItem.vue?vue&type=template&id=f4613f94&scoped=true"
import script from "./attachmentsItem.vue?vue&type=script&lang=js"
export * from "./attachmentsItem.vue?vue&type=script&lang=js"
import style0 from "./attachmentsItem.vue?vue&type=style&index=0&id=f4613f94&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4613f94",
  null
  
)

export default component.exports